<template>
  <div class="financial-institution-editor">
    <label class="label">ชื่อ</label>
    <el-input
      class="input"
      v-model="value.name"
      @input="handleChangeInput('name', $event)"
    ></el-input>
    <label class="label">ชื่อย่อ (ภาษาอังกฤษ)</label>
    <el-input
      class="input"
      v-model="value.code"
      @input="handleChangeInput('code', $event)"
    ></el-input>
  </div>
</template>

<script>
import { Input } from "element-ui";

export default {
  props: ["value"],
  components: {
    "el-input": Input
  },
  methods: {
    handleChangeInput(key, value) {
      this.$emit("input", {...this.value, [key]: value});
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;
}

</style>


// WEBPACK FOOTER //
// src/features/financial-institutions/components/FinancialInstitutionEditor.vue